import { render, staticRenderFns } from "./AdminProductListLite.vue?vue&type=template&id=74786a13&scoped=true"
import script from "./AdminProductListLite.vue?vue&type=script&lang=js"
export * from "./AdminProductListLite.vue?vue&type=script&lang=js"
import style0 from "./AdminProductListLite.vue?vue&type=style&index=0&id=74786a13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74786a13",
  null
  
)

export default component.exports